import { render, staticRenderFns } from "./RootsAndSquaresForm.vue?vue&type=template&id=23852598&scoped=true&lang=pug&"
import script from "./RootsAndSquaresForm.vue?vue&type=script&lang=js&"
export * from "./RootsAndSquaresForm.vue?vue&type=script&lang=js&"
import style0 from "./RootsAndSquaresForm.vue?vue&type=style&index=0&id=23852598&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23852598",
  null
  
)

export default component.exports